import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT, IEnvironment } from '@trade-platform/ui-utils';
import { OrderSignPayload } from '@trade-platform/ui-shared';

@Injectable()
export class OrderSignService {
    private http = inject(HttpClient);
    private environment = inject<IEnvironment>(ENVIRONMENT);

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {}

    orderSign(orderId: string): Observable<OrderSignPayload> {
        return this.http.put<OrderSignPayload>(
            `${this.environment.api}orders/${orderId}/recipient`,
            {
                id: orderId
            }
        );
    }
}
